import type * as React from 'react';

import { useMetaConfig } from '@xing-com/hub';

import { Footer } from './footer';

export const FooterLoggedout: React.FC<{ homeLink: string }> = ({
  homeLink,
}) => {
  const { data } = useMetaConfig();

  return (
    <Footer
      homeLink={homeLink}
      footerConfig={data?.navigation.loggedOutFooter ?? []}
      legalFooterConfig={data?.navigation.loggedOutlegalFooter ?? []}
    />
  );
};
